import { prettifyInlineJsonString, sleep } from "@/utils";
import axios from "axios";

async function checkSignalingSocketConnectivity(check) {
  console.log(`${check.title} Check Started`);

  let reply = { isPassed: false, details: "Not Working!" };

  let apiUrl = window.CONFIG?.SIGNALING_URL || axios.defaults.baseURL;
  let socketProtocol = apiUrl.startsWith("https") ? "wss" : "ws";
  let host = new URL(apiUrl).host;
  const signalingSocketUrl = socketProtocol + "://" + host + "/ws";
  let signalingSocket = new WebSocket(signalingSocketUrl);

  let isOpened = false;
  let isErrored = false;
  let isClosed = false;
  let isReceived = false;
  let isTimedOut = false;

  await Promise.race([
    new Promise((resolve) => {
      signalingSocket.onerror = function (event) {
        isErrored = true;
        reply.details = prettifyInlineJsonString(JSON.stringify(event));
        console.error(event);
        resolve();
      };

      signalingSocket.onclose = function (e) {
        isClosed = true;
        console.log("WebSocket closed:", e);
        reply.details = `WebSocket closed: ${prettifyInlineJsonString(e.data)}`;
        resolve();
      };

      signalingSocket.onopen = async function () {
        isOpened = true;
        await sleep(100);
        signalingSocket.send(JSON.stringify({ cmd: "ping" }));
        await sleep(100);
        signalingSocket.close();
      };

      signalingSocket.onmessage = function (event) {
        isReceived = true;
        reply.details = `Received: ${prettifyInlineJsonString(event.data)}`;
        console.log("Received WebSocket message from signaling server", event.data);
      };
    }),
    new Promise((resolve) => setTimeout(() => {
      isTimedOut = true;
      resolve();
    }, 10000)),
  ]);

  if (isTimedOut) {
    try { signalingSocket.close(); } catch (_) {}
    reply.details = `Error: Connection timed out after 10 seconds.`;
    reply.isPassed = false;
    reply.details = `${check.title}: ${reply.details}`;
    return reply;
  }

  if (isErrored) {
    reply.details = `Error: ${reply.details}`;
    reply.isPassed = false;
    signalingSocket.close();
    return reply;
  }

  if (!isReceived && isOpened) {
    reply.details = `Error: WebSocket opened but no response received.`;
    reply.isPassed = false;
  }

  if (isOpened && isClosed && isReceived && !isErrored) {
    reply.isPassed = true;
    reply.details = "Working properly.";
  }

  reply.details = `${check.title}: ${reply.details}`;
  return reply;
}

export default checkSignalingSocketConnectivity;
